import { Box, Spacer, TextNew } from '@jfs/ui-new'
import { useCallback } from 'react'
import { FlatList } from 'react-native-gesture-handler'
import { ExpandableTextView } from '../../../../components/ExpandableTextView'
import { dateFormatter, DateFormatTypes } from '../../../../utils'
import { TextInputWithInfo } from '../comps/TextInputWithInfo'
import { styles } from './styles'

export const kycApprovalForm = (editable, showRiskInternalComments) => ({
  key: 'KYC_FORM',
  verticalFlex: 1,
  contentOverflow: 'auto',
  horizontalFlex: 1,
  contentPadding: 24,
  title: 'KYC Approval Data',
  formItems: [
    {
      horizontalComps: [
        {
          fieldName: 'applicationId',
          ComponentName: TextInputWithInfo,
          label: 'Application ID',
          title: 'Select Application ID',
          ...styles.textinputStyle(editable),
        },
        {
          fieldName: 'applicationStatus',
          ComponentName: TextInputWithInfo,
          label: 'Application Status',
          title: 'Select Application Status',
          ...styles.textinputStyle(editable),
        },
        {
          fieldName: 'createdAt',
          ComponentName: TextInputWithInfo,
          label: 'Created At',
          title: 'Select Created At',
          ...styles.textinputStyle(editable),
        },
      ],
      horizontalSpacing: 8,
    },

    {
      fieldName: 'comments',
      ComponentName: CommentsDataComp,
      showRiskInternalComments,
    },
  ],
  onSubmit: async (values) => {},
})

const CommentsDataComp = (props) => {
  console.log('CommentsDataComp', props)
  const getUserRole = useCallback((applicationState, isRisk) => {
    if (['OPS_CHECKER_ONE', 'OPS_HOLD', 'OPS_CHECKER_REWORK'].includes(applicationState)) {
      return 'Checker 1'
    } else if (['OPS_CHECKER_TWO', 'RISK_APPROVED', 'RISK_REJECT'].includes(applicationState)) {
      return 'Checker 2'
    } else if (['RISK_MAKER', 'RISK_HOLD'].includes(applicationState)) {
      return 'Risk Maker'
    } else if (['RISK_CHECKER_ONE'].includes(applicationState)) {
      return 'Risk Checker'
    } else if (['SUBMITTED'].includes(applicationState)) {
      return isRisk ? 'Risk Maker' : 'Maker'
    }
    return applicationState ?? 'NA'
  }, [])

  const renderItem =
    (isRisk) =>
    ({ item: { applicationState, comment, createdBy, time } }) => {
      return (
        <Box borderWidth={1} borderColor={'BORDER_COLOR'} pv={8} ph={16}>
          <TitleDetailsComponent title={'User Role'} details={getUserRole(applicationState, isRisk)} />
          <TitleDetailsComponent title={'Comments'} details={comment} />
          <TitleDetailsComponent title={'User Name'} details={createdBy?.userId ?? 'NA'} />
          <TitleDetailsComponent
            title={'Time'}
            details={createdBy?.userId ? dateFormatter(time, DateFormatTypes.DATE_AM_PM) : 'NA'}
          />
        </Box>
      )
    }

  const TitleDetailsComponent = ({ title, details }) => {
    return (
      <Box flexDirection={'row'} marginBottom={8}>
        <Box width={140} justify="center">
          <TextNew {...styles.titleText}>{title} </TextNew>
        </Box>
        <Box width={'80%'} justify="center">
          <ExpandableTextView
            text={details}
            rowData={{ [title]: details }}
            commentsData={[{ key: [title], heading: [title] }] as any}
            backgroundColor="BACKGROUND"
          />
        </Box>
      </Box>
    )
  }

  const listEmptyComponent = (
    <Box marginLeft={4}>
      <TextNew fontSize={12}>No comments available.</TextNew>
    </Box>
  )

  return (
    <Box>
      <TextNew {...styles.detailsText} fontSize={14}>
        Ops Comments
      </TextNew>
      <Spacer size={16} />
      <FlatList
        data={props?.allValues?.opsComments?.filter((item) => !!item.comment) ?? []}
        renderItem={renderItem(false)}
        ListEmptyComponent={listEmptyComponent}
      />
      <Spacer size={32} />
      <TextNew {...styles.detailsText} fontSize={14}>
        {' '}
        Risk Ops Comments
      </TextNew>
      <Spacer size={8} />
      <FlatList
        data={props?.allValues?.riskCommentForOps?.filter((item) => !!item.comment) ?? []}
        renderItem={renderItem(true)}
        ListEmptyComponent={listEmptyComponent}
      />
      <Spacer size={32} />
      {props.showRiskInternalComments && (
        <>
          <TextNew {...styles.detailsText} fontSize={14}>
            {' '}
            Risk Ops Internal Comments
          </TextNew>
          <Spacer size={8} />
          <FlatList
            data={props?.allValues?.riskInternalComment?.filter((item) => !!item.comment) ?? []}
            renderItem={renderItem(true)}
            ListEmptyComponent={listEmptyComponent}
          />
        </>
      )}
    </Box>
  )
}
